import { getOrganizationId } from '@lib/graphql/variables/organizationId'
import { constructUrlWithOrgId } from '@mono/packages/utils/router'
import { NextRouter, useRouter as useNextRouter } from 'next/router'
import { useCallback, useMemo } from 'react'

export interface NextRouterExtended extends NextRouter {
  pushRoot: NextRouter['push']
  replaceRoot: NextRouter['replace']
}

export const useRouter: () => NextRouterExtended = () => {
  const nextRouter = useNextRouter()
  const orgId = getOrganizationId()

  const push: NextRouter['push'] = useCallback(
    (url, as, options) => {
      const urlWithOrgId = constructUrlWithOrgId({ orgId, url })

      return nextRouter.push(urlWithOrgId, as, options)
    },
    [nextRouter, orgId]
  )

  const replace: NextRouter['replace'] = useCallback(
    (url, as, options) => {
      const urlWithOrgId = constructUrlWithOrgId({ orgId, url })

      return nextRouter.replace(urlWithOrgId, as, options)
    },
    [nextRouter, orgId]
  )

  const router = useMemo(
    () => ({
      ...nextRouter,
      pushRoot: nextRouter.push,
      replaceRoot: nextRouter.replace,
      push,
      replace,
    }),
    [nextRouter, push, replace]
  )

  return router
}
